function comparisonPictureChange(e,direction){
        e.preventDefault();

        // 去除所有的激活状态
        $(".pictureTab").removeClass('activeTab');
        // 为被点击的页签加上激活状态
        $('.'+direction+'PictureTab').addClass('activeTab');


        // 隐藏所有图片
        $(".contrastPicture-mobile .contrastPicture-pictureDiv .comparisonPicture .picture").css('display','none');
        // 显示指定对应的图片
        $("."+direction+'Picture').css('display','flex');

    }